/**
 * Checkbox Component - Template
 * =============================
 */

import { BASE_CLASSES } from './constants';

export const CHECKBOX_TEMPLATE: string = `
<label class="ec-checkbox" ng-class="$ctrl.getWrapperClasses()">
  <input
    ng-attr-id="{{ $ctrl.resolvedId }}"
    type="checkbox"
    class="${BASE_CLASSES.input}"
    ng-model="$ctrl.checked"
    ng-change="$ctrl.handleChange()"
    ng-disabled="$ctrl.disabled"
    ng-focus="$ctrl.focused = true"
    ng-blur="$ctrl.focused = false"
    ng-attr-aria-label="{{ (!$ctrl.label && !$ctrl.hasLabelSlot) ? $ctrl.ariaLabel : undefined }}"
  />
  <span
    ng-if="$ctrl.checked"
    ng-class="$ctrl.getBoxClasses()"
    ng-bind-html="$ctrl.trustedCheck"
    aria-hidden="true"
  ></span>
  <span
    ng-if="!$ctrl.checked"
    ng-class="$ctrl.getBoxClasses()"
    ng-bind-html="$ctrl.trustedUncheck"
    aria-hidden="true"
  ></span>
  <span ng-if="$ctrl.label || $ctrl.hasLabelSlot" ng-class="$ctrl.getLabelClasses()"><span ng-if="$ctrl.hasLabelSlot" ng-transclude="labelSlot"></span><span ng-if="!$ctrl.hasLabelSlot">{{ $ctrl.label }}</span></span>
</label>
`;

export default CHECKBOX_TEMPLATE;
